<template>
	<div class="listingSidebar col-12 sidebar">
		<h2 class="sidebarH2">Filter Products</h2>
		<SubsubcategoryFilter :allProducts="allProducts" :products="products"/>
		<BrandsFilter :allProducts="allProducts" :brandsData="brandsData" />
		<!-- <PricesFilter :allProducts="allProducts" :products="products"/>-->
		<!--<ListingBrandsSidebar :brandsData="brandsData" :listingName="listingName" class="d-none d-md-block"/>-->
		<ClearFiltersButton class="btn btn-primary clearFiltersSidebar"/>

		<OrderBy />
	</div>
</template>

<script>
import SubsubcategoryFilter from "./ListingSidebarSubSubCategoryFilter";
import BrandsFilter from "./ListingSidebarBrandsFilter";
import OrderBy from "./ListingSidebarOrderBy";

// import PricesFilter from "./ListingSidebarPricesFilter";
// import ListingBrandsSidebar from "./ListingBrandsSidebar";

import ClearFiltersButton from "@/components/buttons/ClearFiltersButton";

export default {
	name: "ListingSidebar",
	props: ["allProducts", "products", "brandsData", "showMobile", "listingName"],
	components: {
		BrandsFilter,
		// PricesFilter,
		SubsubcategoryFilter,
		ClearFiltersButton,
		OrderBy,
		// ListingBrandsSidebar
	},
	methods: {
		clearfilters() {
			this.$router.replace({ query: null });
		},
	}
};
</script>

<style lang="scss" scoped>

.sidebar{
  font-size: 0.9rem;
}

@include media-breakpoint-down(sm){
  .sidebarInner{
    display:none;
    &.expanded{
      display:block
    }
  }
}
// sidebar styles are set in the sidebar.scss file in styles folder, changes will affect other sidebars
</style>
